package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.px

private const val UNDERLINE_HEIGHT_PX = 2

@Composable
fun TabUnderline(tabCount: Int, activeIndex: Int) {
    Box(
        modifier = Modifier
            .classNames("sb-tab-underline")
            .height(UNDERLINE_HEIGHT_PX.px)
            .backgroundColor(Palette.accent)
            .styleModifier {
                property("position", "absolute")
                property("left", "0")
                property("bottom", "0")
                property("width", "calc(100% / $tabCount)")
                property("transform", "translateX(${activeIndex * 100}%)")
            },
    )
}
